import * as THREE from "three";

const CAPSULE_RADIUS = 0.4;
const CAPSULE_HEIGHT = 1.8;

/**
 * Yellow translucent backface-rendered capsule, slightly larger than the player.
 * Attach by adding to the player's group; detach by removing.
 */
export function makeTargetAura(): THREE.Mesh {
  const geom = new THREE.CapsuleGeometry(
    CAPSULE_RADIUS * 1.1,
    (CAPSULE_HEIGHT - 2 * CAPSULE_RADIUS) * 1.1,
    6,
    12,
  );
  const mat = new THREE.MeshBasicMaterial({
    color: 0xfff066,
    transparent: true,
    opacity: 0.45,
    side: THREE.BackSide,
    depthWrite: false,
  });
  const mesh = new THREE.Mesh(geom, mat);
  mesh.position.y = CAPSULE_HEIGHT / 2;
  return mesh;
}

export function disposeAura(mesh: THREE.Mesh) {
  mesh.geometry.dispose();
  (mesh.material as THREE.Material).dispose();
}
